<template>
  <ShallowCard>
    <div class="flex items-center">
      <div style="min-width: 1px; flex: 1 1 auto;">
        <CardSparte :sparte="sparte" />
        <div
          v-if="contractNumber"
          class="text-xs text-muted truncate"
          :title="`Vertragsnummer ${contractNumber}`"
        >
          {{ contractNumber }}
        </div>
        <CardGesellschaft
          :id="depot.company.id"
          :name="depot.company.name"
          style="margin-top: 13px;"
        />
      </div>
      <div
        style="min-width: 1px; flex: 1 1 125px;"
        class="ml-5"
      >
        <div class="text-right">
          <ContractPayment
            :amount="depot.depot_evaluation"
            bold
          />
        </div>
      </div>
    </div>

    <CardMeta class="py-1.5">
      <div class="pr-2.5 flex flex-col grow items-start min-w-0 gap-3 text-xs md:sm">
        <ContractPayment
          v-if="typeof depot.monthly_payment_rate === 'number'"
          inline
          :amount="depot.monthly_payment_rate ?? null"
        >
          <span class="ml-1 whitespace-nowrap">Monatliche Sparrate</span>
        </ContractPayment>
        <CardOwner
          v-if="owner"
          :owner="owner"
        />
        <CardCoinsured
          v-else
          :coinsured="coinsured"
        />
      </div>
      <div
        v-if="depot.depotFonds !== undefined || documentsCount > 0"
        class="ml-2.5 shrink-0 self-stretch flex flex-col items-end"
      >
        <CardDocumentsIcon :count="documentsCount" />
        <div
          v-if="depot.depotFonds !== undefined"
          class="mt-auto flex items-center text-xs md:text-sm"
        >
          <FaIcon
            name="align-justify"
            fixed-width
            class="text-gray-500 mr-1"
          />
          {{ depot.depotFonds.length }}
          {{ depot.depotFonds.length === 1 ? 'Fond' : 'Fonds' }}
        </div>
      </div>
    </CardMeta>
  </ShallowCard>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { Coinsured, Depot, Owner } from '@/api/contracts/types';
import CardCoinsured from '@/contracts/components/CardCoinsured.vue';
import CardDocumentsIcon from '@/contracts/components/CardDocumentsIcon.vue';
import CardGesellschaft from '@/contracts/components/CardGesellschaft.vue';
import CardMeta from '@/contracts/components/CardMeta.vue';
import CardOwner from '@/contracts/components/CardOwner.vue';
import CardSparte from '@/contracts/components/CardSparte.vue';
import ContractPayment from '@/contracts/components/ContractPayment.vue';
import ShallowCard from '@/contracts/components/ShallowCard.vue';
import { getShortSparteName } from '@/application/utils/sparteFormatter';
import FaIcon from '@/application/components/ui/FaIcon.vue';

interface Props {
  depot: Depot,
  contractNumber?: string | null,
  documentsCount?: number,
  coinsured?: Coinsured[],
  owner?: Owner | null,
}

const props = withDefaults(defineProps<Props>(), {
  contractNumber: null,
  documentsCount: 0,
  coinsured: () => [],
  owner: null,
});
const sparte = computed(() => getShortSparteName(props.depot.product?.name));

</script>
